import React from 'react';

import style from './index.module.scss';

const KimSuppliersDynamicsInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Поставщики+динамика КИМ</h1>

    <div className={style.description}>
      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Сервис позволяет посмотреть информацию по ценовым запросам Заказчиков в разрезе регионов и поставщиков.
        </div>
      </div>
    </div>
  </>
);

export default KimSuppliersDynamicsInfo;
